import showToast from '../components/ToastComponent';
import { useState } from 'react';
import { validateEmailFilterData } from '../service/validateEmailFilterData';
import { BulkEmailConfig } from '../interface/interface';

const useValidatePayload = (): [
  boolean,
  (
    accessToken: string | undefined,
    payload: BulkEmailConfig,
    isValid: (arg0: boolean) => void,
  ) => Promise<void>,
  string,
] => {
  const [loading, setLoading] = useState<boolean>(false);
  const [taskExecutionId, settaskExecutionId] = useState<string>('');

  const validatePayload = async (
    accessToken: string | undefined,
    payload: BulkEmailConfig,
    isValid: (arg0: boolean) => void,
  ) => {
    if (!accessToken) return;

    const response = await validateEmailFilterData(accessToken!, payload);
    if (typeof response === 'number') {
      showToast({
        type: 'warning',
        message: 'Unable to validate payload. incorrect payload data',
      });
      setLoading(false);
      isValid(false);
      return;
    } else {
      settaskExecutionId(response);
      setLoading(false);
      isValid(true);
    }
  };

  return [loading, validatePayload, taskExecutionId];
};

export default useValidatePayload;
